import { STATE_KEY } from './constants';

export const SET_SITE_ATTRIBUTE_GROUPS = `${STATE_KEY}/SET_SITE_ATTRIBUTE_GROUPS`;
export const CLEAR_SITE_ATTRIBUTE_GROUPS = `${STATE_KEY}/CLEAR_SITE_ATTRIBUTE_GROUPS`;
